module.exports = __webpack_public_path__ + "img/home.f6f02b06.png";